var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappiness = function SvgHappiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#happiness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.629 12c0 5.87-4.759 10.629-10.629 10.629S1.371 17.87 1.371 12 6.13 1.371 12 1.371 22.629 6.13 22.629 12M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-5.743.918c.468.074.792.515.664.97a7.273 7.273 0 0 1-11.787 3.51 7.27 7.27 0 0 1-2.245-3.609c-.122-.457.208-.893.677-.96l.103-.015c.469-.068.897.261 1.036.714a5.45 5.45 0 0 0 5.175 3.846 5.45 5.45 0 0 0 3.568-1.296 5.44 5.44 0 0 0 1.66-2.477c.146-.45.578-.773 1.046-.7zM9.771 8.914a1.543 1.543 0 1 1-3.085 0 1.543 1.543 0 0 1 3.085 0m6 1.543a1.542 1.542 0 1 0 .001-3.086 1.543 1.543 0 1 0 0 3.086z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "happiness_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHappiness;